import { useEffect, useMemo, useState } from "react";
import { customStatuses } from "../../utils/customStatuses";

interface ProcessingStatusProps {
    progress: any;
}

const ProcessingStatus: React.FC<ProcessingStatusProps> = ({ progress }) => {
    const {
        currentStep,
        imagesProcessed,
        videosProcessed,
        totalImages,
        totalVideos,
    } = progress;

    const counter = useMemo(() => {
        if (totalImages && imagesProcessed < totalImages) {
            return imagesProcessed;
        } else if (totalVideos && videosProcessed < totalVideos) {
            return videosProcessed;
        }
        return 0;
    }, [totalImages, imagesProcessed, totalVideos, videosProcessed]);

    const [isStalled, setIsStalled] = useState(false);
    const [displayStatus, setDisplayStatus] = useState(currentStep);

    // MB-1611: a listing parked on an MLS feed outage says so and keeps saying
    // so. The playful filler below is for a step that is genuinely working.
    const isWaitingOnFeed =
        typeof currentStep === "string" && currentStep.startsWith("Waiting for MLS");

    useEffect(() => {
        setIsStalled(false);
        setDisplayStatus(currentStep);
        if (isWaitingOnFeed) return undefined;

        const timer = setTimeout(() => {
            setIsStalled(true);
        }, 3000);

        return () => clearTimeout(timer);
    }, [counter, currentStep, isWaitingOnFeed]);

    useEffect(() => {
        if (!isStalled) return;
        const intervalId = setInterval(() => {
            const randomIndex = Math.floor(
                Math.random() * customStatuses.length
            );
            setDisplayStatus(customStatuses[randomIndex]);
        }, 1500);

        return () => clearInterval(intervalId);
    }, [isStalled]);

    return <span>{displayStatus}</span>;
};

export default ProcessingStatus;
